import { freehandTextElements } from './freehandTextElements';
import { barcodeElements } from './barcodeElements';
import { lineElements } from './lines';
import { shapesElements } from './shapes';
import { fillableElements } from './fillableInputs';
import { MASTER_ELEMENTS_CATEGORIES as trans } from './translationValues';
import { tableElements } from './tableElements';
import { chartElements } from './chartElements';

export const masterElements = (t, currentLanguage = 'en', currentBlockType) => {
  let freehandTexts = freehandTextElements(t, currentLanguage);
  let barcodes = barcodeElements(t, currentLanguage);
  let lines = lineElements(t, currentLanguage);
  let shapes = shapesElements(t, currentLanguage);
  let fillableInputs = fillableElements(t, currentLanguage, currentBlockType);
  let tableElement = tableElements(t, currentLanguage);
  const chartElement = chartElements(t, currentLanguage);

  return [
    {
      categoryId: 1,
      categoryName: t(
        `MASTER_ELEMENTS_CATEGORIES:${trans.TEXT_CATEGORY_LABEL.key}`,
        trans.TEXT_CATEGORY_LABEL.value,
      ),
      elements: [...freehandTexts],
    },
    {
      categoryId: 2,
      categoryName: t(
        `MASTER_ELEMENTS_CATEGORIES:${trans.SHAPE_CATEGORY_LABEL.key}`,
        trans.SHAPE_CATEGORY_LABEL.value,
      ),
      elements: [...shapes],
    },
    {
      categoryId: 3,
      categoryName: t(
        `MASTER_ELEMENTS_CATEGORIES:${trans.BARCODE_CATEGORY_LABEL.key}`,
        trans.BARCODE_CATEGORY_LABEL.value,
      ),
      elements: [...barcodes],
    },
    {
      categoryId: 4,
      categoryName: t(
        `MASTER_ELEMENTS_CATEGORIES:${trans.FORM_CATEGORY_LABEL.key}`,
        trans.FORM_CATEGORY_LABEL.value,
      ),
      elements: [...fillableInputs],
    },
    {
      categoryId: 5,
      categoryName: t(
        `MASTER_ELEMENTS_CATEGORIES:${trans.LINE_CATEGORY_LABEL.key}`,
        trans.LINE_CATEGORY_LABEL.value,
      ),
      elements: [...lines],
    },
    {
      categoryId: 6,
      categoryName: t(
        `MASTER_ELEMENTS_CATEGORIES:${trans.TABLE_CATEGORY_LABEL.key}`,
        trans.TABLE_CATEGORY_LABEL.value,
      ),
      elements: [...tableElement],
    },
    {
      categoryId: 7,
      categoryName: t(
        `MASTER_ELEMENTS_CATEGORIES:${trans.CHART_CATEGORY_LABEL.key}`,
        trans.CHART_CATEGORY_LABEL.value,
      ),
      elements: [...chartElement],
    },
  ];
};
